import $ from 'jquery'
import manager from '../manager'
import { isEditorPage } from '@/utils/page'
import _ from 'lodash'
manager.add('affix', {
	created(top) {
		if (isEditorPage()) {
			return;
		}
		var isFixed = false
		var domTop, domWidth, domHeight
		var fixBox = $("<div></div>")
		var holderBox = $("<div></div>").append(fixBox)
		$(this.dom).after(holderBox)
		fixBox.append(this.dom)
		let _scrollHandler=e=>{  
			var scrollTop = $(e.currentTarget).scrollTop();
			if (!isFixed) {
				domTop = $(this.dom).offset().top
				domWidth = $(this.dom).width()
				domHeight = $(this.dom).height()
			}
			if (domTop < scrollTop) {
				isFixed = true
				holderBox.css({ width: domWidth, height: domHeight })
				fixBox.css({ position: "fixed", "z-index": 101, "width": domWidth, top: top || 0, "box-shadow": "0 0px 5px rgba(0,0,0,0.2)" })
			} else {
				isFixed = false
				holderBox.attr({ style: null })
				fixBox.attr({ style: null })
			}
		}
		this.scrollHandler=_.throttle(_scrollHandler,50)
		$(window).on("touchmove",this.scrollHandler)
		$(window).on("scroll",this.scrollHandler)
	},
	destroyed() {
		if (isEditorPage()) {
			return;
		}
		$(window).off("touchmove",this.scrollHandler)
		$(window).off("scroll",this.scrollHandler)
	}
})
